module.exports = __webpack_public_path__ + "static/approve-export-timesheets-25026be0df794c17cdcce7f6df4b5e5c.png";